import BaseController from "./BaseController";
import BootstrapMenu from "bootstrap-menu";
import constants from "../constants/Constants";
import $ from "jquery";
import mobileListService from "../service/mobile/MobileListService";
import contextMarginBottom from "../../templates/mobile/mobile-context-margin-bottom.ejs";
import contextMarginTop from "../../templates/mobile/mobile-context-margin-top.ejs";
import contextMarginTopBottom from "../../templates/mobile/mobile-context-margin-topBottom.ejs";
import contextMarginNone from "../../templates/mobile/mobile-context-margin-none.ejs";
import listService from "../service/ListService";
import mobileConstants from '../mobile/commons/MobileFormsConstants';
import eventBus from '../service/EventBus';
import util from "../service/util/Util";
import focusController from "./FocusController";


class MobileContextMenuController extends BaseController {

    constructor() {
        super();
        let self = this;

        this._options = {
            fetchElementData: function ($elem) {
                const id = $elem.first('div').attr('id');
                if (id) {
                    const mobileControl = mobileListService.getMobileControl(id);
                    if (mobileControl){
                        let factory = mobileControl.model.get('factoryKey');
                        if(factory.startsWith('control') && factory !== mobileConstants.SECTION_FACTORY_KEY) {
                            self.changeObjectSelection(id);
                   
                             $elem.enabled = true;
                            this.actions.header.name = `<span class="context-item">${mobileControl.model.get('name')}</span>`;
                            Object.keys(this.actions).forEach(key => {
                                this.actions[key].id = id;
                            });

                            if(factory === mobileConstants.CHECKBOX_FACTORY_KEY && mobileControl.model.get("groupContainer")){
                                $elem.enabled = false;
                            }

                            $('#mobile-designer-context-menu').css('visibility', 'visible');

                            setTimeout(()=> {
                                eventBus.trigger('selectRightMarginOption');
                            });
                        }

                    } else {
                        $('#mobile-designer-context-menu').css('visibility', 'hidden');
                    }
                    
                }
                return $elem;
            },
            actionsGroups: [
                ['header','marginHeader', 'bottomMargin', 'topMargin', 'topBottomMargin', 'noneMargin'],
                ['deleteItem']
            ],
            actions: {
                header: {
                    id: '',
                    name: `<span class="context-item"></span>`,
                    onClick: function () {},
                    isEnabled: function () { return true; }
                },
                marginHeader: {
                    id: '',
                    name: `<span class="context-item">Margin</span>`,
                    onClick: function () {},
                    isEnabled: function () { return true; }
                },
                bottomMargin: {
                    id: '',
                    name: contextMarginBottom,
                    onClick: function () {
                        const mobileControl = mobileListService.getMobileControl(this.id);
                        mobileControl.model.set(mobileConstants.MARGIN_ATTRIBUTE_NAME,
                                                mobileConstants.BOTTOM_MARGIN,
                                                constants.MODEL_SILENT);
                        mobileControl.render();
                    },
                    isEnabled: function () { return true; }
                },
                topMargin: {
                    id: '',
                    name: contextMarginTop,
                    onClick: function () {
                        const mobileControl = mobileListService.getMobileControl(this.id);
                        mobileControl.model.set(mobileConstants.MARGIN_ATTRIBUTE_NAME,
                                                mobileConstants.TOP_MARGIN,
                                                constants.MODEL_SILENT);
                        mobileControl.render();
                    },
                    isEnabled: function () { return true; }
                },
                topBottomMargin: {
                    id: '',
                    name: contextMarginTopBottom,
                    onClick: function () {
                        const mobileControl = mobileListService.getMobileControl(this.id);
                        mobileControl.model.set(mobileConstants.MARGIN_ATTRIBUTE_NAME,
                                                mobileConstants.TOP_BOTTOM_MARGIN,
                                                constants.MODEL_SILENT);
                        mobileControl.render();
                    },
                    isEnabled: function () { return true; }
                },
                noneMargin: {
                    id: '',
                    name: contextMarginNone,
                    onClick: function () {
                        const mobileControl = mobileListService.getMobileControl(this.id);
                        mobileControl.model.set(mobileConstants.MARGIN_ATTRIBUTE_NAME,
                                                mobileConstants.NONE_MARGIN,
                                                constants.MODEL_SILENT);
                        mobileControl.render();
                    },
                    isEnabled: function () { return true; }
                },
                deleteItem: {
                    id: '',
                    name: '<span class="context-item">Remove item</span>',
                    onClick: function () {
                        const mobileObject = listService.getMobileObject(this.id);
                        const sectionId = mobileObject.sectionId;
                        listService.deleteMobileObjectbyId(this.id);
                        mobileListService.deleteMobileControlbyId(this.id);
                        mobileListService.getMobileControl(sectionId).render();
                    },
                    isEnabled: function (object) {
                        return object.enabled;
                    }
                }
            }
        };
       
        this._menu = new BootstrapMenu(".pf-control.has-menu, .pf-section-control", this._options);

        $(constants.CONTENT_ID).on('keyup', this.handleKeyUp.bind(this));
        $('.dropdown.bootstrapMenu').attr('id','mobile-designer-context-menu');
        $('#mobile-designer-context-menu>.dropdown-menu').css('padding-top','0');
        $('#mobile-designer-context-menu>.dropdown-menu>li:nth-child(1)>a').css('background-color','#C0C0C0');
        $('#mobile-designer-context-menu>.dropdown-menu>li:nth-child(1)>a').css('font-weight','bold');
        $('#mobile-designer-context-menu>.dropdown-menu>li:nth-child(1)>a').mouseover(function () {
            $(this).css('background-color','#C0C0C0');
            $(this).css('color','#333333');
            $(this).css('font-weight','bold');
        });
        $('#mobile-designer-context-menu>.dropdown-menu>li:nth-child(2)>a').mouseover(function () {
            $(this).css('background-color','#FFFFFF');
            $(this).css('color','#333333');
        });

        for (let index = 3; index <= 6;index++) {
            $(`#mobile-designer-context-menu>.dropdown-menu>li:nth-child(${index})`).css('display', 'inline-block');
            if (3 === index) {
                $(`#mobile-designer-context-menu>.dropdown-menu>li:nth-child(${index})>a`).attr('style', 'background-color: #FFFFFF; padding: 0 0 0 20px !important');
            } else {
                $(`#mobile-designer-context-menu>.dropdown-menu>li:nth-child(${index})>a`).attr('style', 'background-color: #FFFFFF; padding: 0 !important');
            }
        }
    }

    changeObjectSelection(id){
        $('.pf-selectable').removeClass('pfSelected');
        listService.clearSelected();
        listService.addToSelected(id);
        util.jqId(id).find(".pf-selectable").addClass('pfSelected');
        listService.currentId = id;
        focusController.selectionRectangle(id);
        focusController.switchPropsViews();
    }

    handleKeyUp(ev) {
        if (ev.keyCode === constants.KEY_ESC) {
            $(constants.CONTENT_ID).trigger('click');
        }
    }

    get menu() {
        listService.clearSelected();
        return this._menu;
    }

    remove() {
        $(constants.CONTENT_ID).off('keyup', handleKeyUp);
        this._menu.destroy();
        super.remove();
    }
}

export default MobileContextMenuController;